import { INew_TableAction } from '@lla-platform/core/core-data-access'
import {
  IUsafStockCheckBranch,
  IUsafStockCheckLineRequest,
  IUsafStockCheckResult,
  IUsafSubmitOrderRequest
} from '../../interfaces/usaf-order.interface'
import { IUsafRefillSubmitRequest } from '../../interfaces/usaf-refill.interface'

export class GetUsafOrderHistory {
  static readonly type = '[usaf] Get Order History'
  constructor(public locationId: string) {}
}

export class RefreshUsafOrderStatuses {
  static readonly type = '[usaf] Refresh Order Statuses'
  constructor(public locationId: string) {}
}

export class CheckUsafStock {
  static readonly type = '[usaf] Check Stock'
  constructor(
    public locationId: string,
    public lines: IUsafStockCheckLineRequest[]
  ) {}
}

export class ClearUsafStock {
  static readonly type = '[usaf] Clear Stock'
}

export class SetUsafStocks {
  static readonly type = '[usaf] Set Stocks'
  constructor(
    public stocks: Record<string, IUsafStockCheckResult>,
    public branches?: IUsafStockCheckBranch[]
  ) {}
}

export class SubmitUsafOrder {
  static readonly type = '[usaf] Submit Order'
  constructor(public order: IUsafSubmitOrderRequest) {}
}

export class ClearUsafLocationData {
  static readonly type = '[usaf] Clear Location Data'
}

export class SearchUsafTireSuggestions {
  static readonly type = '[usaf] Search Tire Suggestions'
  constructor(
    public query: string,
    public locationId?: string
  ) {}
}

export class ClearUsafTireSuggestions {
  static readonly type = '[usaf] Clear Tire Suggestions'
}

export class GetUsafOrdersList {
  static readonly type = '[usaf] Get Orders List'
  constructor(public info: INew_TableAction) {}
}

export class GetUsafOrdersOverview {
  static readonly type = '[usaf] Get Orders Overview'
  constructor(public info: INew_TableAction) {}
}

export class GetUsafOrderLinesList {
  static readonly type = '[usaf] Get Order Lines List'
  constructor(public info: INew_TableAction) {}
}

export class GetUsafInvoicesList {
  static readonly type = '[usaf] Get Invoices List'
  constructor(public info: INew_TableAction) {}
}

export class GetUsafAutoOrderAttemptsList {
  static readonly type = '[usaf] Get Auto Order Attempts List'
  constructor(public info: INew_TableAction) {}
}

export class GetUsafAutoOrderOverview {
  static readonly type = '[usaf] Get Auto Order Overview'
  constructor(public info: INew_TableAction) {}
}

export class GetUsafLeftoversList {
  static readonly type = '[usaf] Get Leftovers List'
  constructor(public info: INew_TableAction) {}
}

export class GetUsafOverdueOrdersList {
  static readonly type = '[usaf] Get Overdue Orders List'
  constructor(public info: INew_TableAction) {}
}

// Counts/units only (Overview tiles, Automatic banner) — kept apart from the list
// responses so a summary never overwrites the page a list is showing.
export class GetUsafWorkQueueSummary {
  static readonly type = '[usaf] Get Work Queue Summary'
  constructor(
    public leftovers: INew_TableAction,
    public overdueOrders: INew_TableAction
  ) {}
}

export class GetUsafRefillLocations {
  static readonly type = '[usaf] Get Refill Locations'
}

// Dispatched once per location in parallel — never cancels a sibling.
export class GetUsafRefillPlan {
  static readonly type = '[usaf] Get Refill Plan'
  constructor(public locationId: string) {}
}

export class SubmitUsafRefill {
  static readonly type = '[usaf] Submit Refill'
  constructor(public request: IUsafRefillSubmitRequest) {}
}

export class GetUsafOrderDetail {
  static readonly type = '[usaf] Get Order Detail'
  constructor(public orderId: string) {}
}
